import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
} from "baseui/modal";
import { Input } from "baseui/input";
import { RadioGroup, Radio } from "baseui/radio";
import { KIND } from "baseui/button";
import { ACCESS_TYPES } from "../../constants/AppEnums";
const CloneModal = ({
  isOpen,
  onClose,
  onClone,
  headerTitle,
  cloningInProgress,
}) => {
  const [newTitle, setNewTitle] = useState("");
  const [access, setAccess] = useState(ACCESS_TYPES.PUBLIC);
  useEffect(() => {
    setNewTitle("");
    setAccess(ACCESS_TYPES.PUBLIC);
  }, [isOpen]);

  return (
    <Modal closeable={false} onClose={onClose} isOpen={isOpen}>
      <ModalHeader>{headerTitle || "Clone Object"}</ModalHeader>
      <ModalBody>
        <Input
          onBlur={(e) => setNewTitle(e.target.value)}
          onChange={(e) => setNewTitle(e.target.value)}
          error={!newTitle}
          placeholder="Enter title ..."
          clearOnEscape
        />
      <RadioGroup
        
        title="Access"
        onChange={(e) => {
          setAccess(e.target.value);          
        }}
        value={access}
      >
        <Radio
          value={ACCESS_TYPES.PUBLIC}
          description="All registered users can see but only you can modify"
        >
          Public
        </Radio>
        <Radio
          value={ACCESS_TYPES.PRIVATE}
          description="Only you can see and modify"
        >
          Private
        </Radio>
      </RadioGroup>
      </ModalBody>
      <ModalFooter>
        <ModalButton kind={KIND.secondary} disabled={cloningInProgress} onClick={onClose}>
          Cancel
        </ModalButton>
        <ModalButton
          isLoading={cloningInProgress}
          disabled={!newTitle || cloningInProgress}
          onClick={() => newTitle && access && onClone(newTitle, access)}
        >
          Clone
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
};

export default CloneModal;
